import { render } from "./ImportModal.vue?vue&type=template&id=793d21c5&scoped=true"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-793d21c5"

export default script